// The words the typed cells and row actions show.

export const ROW_ACTIONS_LABEL = 'Row actions'

// the name of a split button's menu trigger
export const splitMenuLabel = label => `${label} actions`
